import { useState } from 'react';

import { SketchPicker } from 'react-color';

import { ReactComponent as Cancel } from '../assets/cancel.svg';

export default function Colors ({colors, saveColor, setPicker, picker, hideColors}) {
    
    const [pickerColor, setPickerColor] = useState(false);    
    const changePicker = (color, event) => {        
                
        setPickerColor(color.hex);
        
        let color_element = document.querySelector(".color.active");
        let colorindex = color_element.dataset.colorindex;
        
        saveColor(colorindex, color.hex);
    };
    const openPicker = (event) => {
        
        let index = event.currentTarget.dataset.colorindex;
        let color = event.currentTarget.dataset.color;
        
        setPickerColor(color);
        setPicker(index);
    }
    
    
    return (        
        
        <div className="right right_colors "> 
                                                
            <div className="dashed-border">
            
                <div className="title"> 
                    <div>
                        <div className="name">Select colors</div>
                    </div>
                    <div>
                        <div className="cancel" onClick={hideColors}>
                            <Cancel/>
                            Close
                        </div>                                            
                    </div>
                </div>
                
                <div className="colors">
                    
                    {!!colors && 

                        colors.map( (color, colorIndex) => 
        
                            <div className={
                                picker !== false && picker == colorIndex ?
                                "color active"
                                :
                                "color"                                                                
                            } key={colorIndex} onClick={openPicker} data-colorindex={colorIndex} data-color={color['color']}>
                                <div className="color_bg">
                                    <div style={{background: color['color']}}>
                                
                                        {picker !== false && picker == colorIndex ?
                                        
                                            <SketchPicker
                                                color={pickerColor}
                                                onChange={changePicker}
                                                data-colorindex={colorIndex}
                                            />
                                            
                                            :
                                            
                                            <></>
                                            
                                        }
                                        
                                    </div>
                                </div>
                                <div className="color_name">{color['name']}</div>
                            </div>
                    
                        )                                                        
                    }
                
                </div>
            </div>
        </div>
        
    )

}
